/* eslint-disable
    func-names,
    no-shadow,
    no-underscore-dangle,
    no-unused-vars,
    no-use-before-define,
    prefer-rest-params,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');

const moduleDeps = [require('data/util').name, require('data/model/addon').name];

const addOnCollectionDeps = ['Collection', 'AddOn'];

const addOnCollection = function (Collection, AddOn) {
  let AddOnCollection;
  return (AddOnCollection = (function () {
    AddOnCollection = class AddOnCollection extends Collection {
      static initClass() {
        this.prototype.$id = null;
        this.prototype.$$cacheModels = true;
        this.prototype.$resource = 'addon';
        this.prototype.$type = AddOn;
      }
      $url() {
        return `${super.$url()}/client/${this.$storeId()}`;
      }

      getNameById(id) {
        return __guard__(this.$findById(id), x => x.name);
      }

      $init() {
        super.$init(...arguments);

        if (this.$lastUpdated === 0) {
          return this.$fetch();
        }
      }

      $serialize(data) {
        return super.$serialize(_.orderBy(data, ['order', 'name']));
      }

      $deserialize(data) {
        return super.$deserialize(_.orderBy(data, ['order', 'name']));
      }

      $getIds() {
        return this.data.map(item => item.id);
      }

      $reorder(prevId, nextId) {
        return this.$apiCall({
          url: `${this.$resource}.json/reorder`,
          method: 'PUT',
          data: this.$getIds(),
        });
      }
    };
    AddOnCollection.initClass();
    return AddOnCollection;
  })());
};

addOnCollection.$inject = addOnCollectionDeps;

module.exports = angular
  .module('bench.data.collection.addOn', moduleDeps)
  .factory('AddOnCollection', addOnCollection);

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}
